<template>
  <div
    class="navHeader">
    <van-nav-bar v-if="displayNavBar"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :title="title"
      :border="false"
      left-arrow
    >
      <img v-if="showHome" class="home" src="../assets/home.png" alt slot="right">
    </van-nav-bar>
    <slot></slot>
  </div>
</template>

<script>
import { displayHeader } from "@/utils/common";
import { csairHome } from "@/config/link";
export default {
  name: "Header",
  props: {
    title: {
      type: String,
      default: "标题"
    },
    showHome: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayNavBar() {
      return displayHeader(this.title);
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      window.location.href = csairHome;
    }
  }
};
</script>

<style lang="less" scoped>
.navHeader {
  background: rgb(35, 88, 146);
  /deep/.van-nav-bar {
    background-color: transparent;
    .van-icon {
      color: white;
    }
    .van-nav-bar__title {
      color: white;
    }
    .van-nav-bar__right {
      line-height: 40px;
    }
  }
  .home {
    height: 18px;
  }
}
</style>
